import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@/services/axios-base-query';
import { NOTIFICATION_ROUTES } from '@/constants/api-routes';
import type { NotificationPagination } from '@/types';

export const notificationApi = createApi({
  reducerPath: 'NotificationApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Notifications'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    fetchNotifications: builder.query<
      NotificationPagination,
      { 
        tenant: string; 
        userId: string; 
        page?: number; 
        ordering?: string;
        isRead?: boolean;
      }
    >({
      query: ({ tenant, userId, page = 1, ordering = '-notification__created_date_ad', isRead }) => {
        let url = `${NOTIFICATION_ROUTES.GET_NOTIFICATIONS(tenant)}?user=${userId}&page=${page}&ordering=${ordering}`;
        if (isRead !== undefined) {
          url += `&is_read=${isRead}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['Notifications'],
    }),

    markAllAsRead: builder.mutation<{ message: string }, { tenant: string }>({
      query: ({ tenant }) => ({
        url: NOTIFICATION_ROUTES.MARK_ALL_READ(tenant),
        method: 'GET',
      }),
      invalidatesTags: ['Notifications'],
    }),
  }),
});

export const {
  useFetchNotificationsQuery,
  useLazyFetchNotificationsQuery,
  useMarkAllAsReadMutation,
} = notificationApi;
